export default __webpack_public_path__ + "static/media/gallery_07.cddecb43.jpg";